import React from 'react';
import useCollapsibleOverlay from '../../../../hooks/useCollapsibleOverlay';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Namespace } from '../../../../translation/namespace';
import { Icons } from '../../../../components/atoms/SVG';
import { CollapsibleContent } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay';
import { CollapsibleModifier } from '../../../../components/organisms/CollapsibleOverlay/CollapsibleOverlay.modifier';
import Btn, { BtnModifier } from '../../../../components/molecules/Btn';
import { TextSnippet } from '../../../../components/molecules/SearchResultTeaser/TextSnippet';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

type AttachmentSnippet = {
  snippet: string;
  title: string;
};

export function DownloadAttachmentSnippet({ snippet, title }: AttachmentSnippet) {
  const { t } = useSonTranslation(Namespace.ContentAttachmentList);
  const { collapsibleProps, toggleProps, collapsibleOpen } = useCollapsibleOverlay('right');
  const text = t('searchHit', { title });
  return (
    <div className="download__snippet-text-button">
      <Btn
        type="button"
        modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
        svgSpriteId={collapsibleOpen ? Icons.DECLINE_CROSS : Icons.SEARCH_HIT}
        ariaControls={toggleProps['aria-controls']}
        ariaExpanded={toggleProps['aria-expanded']}
        hiddenText
        text={text}
        titleText={text}
        tooltipPlacement={TooltipPlacement.TOP}
        onClick={toggleProps.onClick}
        onKeyDown={toggleProps.onKeyDown}
        reference={toggleProps.ref}
      />
      <CollapsibleContent {...collapsibleProps} modifier={CollapsibleModifier.SEARCH_TEXT_SNIPPET}>
        <TextSnippet text={snippet} modifier="collapsible" />
      </CollapsibleContent>
    </div>
  );
}
